/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import PropTypes from 'prop-types';

import ImputationObjectModal from '../ImputationObjectModal/ImputationObjectModal';
import ModalProgramPointApproval from '../ApprovalPending/ViewApprovalPendingContainer/TableApproval/ModalProgramPointApproval/ModalProgramPointApproval';
import ModalIO from '../ApprovalPending/ViewApprovalPendingContainer/TableApproval/ImputationObjectApprovalModal/ModalIO';
import ReplaceLinesSuccessModal from '../WorkReports/ReplaceLinesAlertModal/ReplaceLinesSuccessModal';

import AttachFileModal from './AttachFileModal/AttachFileModal';
import TotalLineModal from './TotalLineModal/TotalLineModal';
import CommentsModal from './CommentsModal/CommentsModal';
import QuantityEntryModal from './QuantityEntryModal/QuantityEntryModal';
import MonthlySummaryModal from './MonthlySummaryModal/MonthlySummaryModal';
import RejectModal from './RejectModal/RejectModal';
import ApproveAllModal from './ApproveAllModal/ApproveAllModal';
import ExpertReviewModal from './ExpertReviewModal/ExpertReviewModal';
import InspectorExpertReviewModal from './InspectorExpertReviewModal/InspectorExpertReviewModal';
import EditQuantityModal from './EditQuantityModal/EditQuantityModal';
import ConfirmApprovalModal from './ConfirmApprovalModal/ConfirmApprovalModal';
import TemplateWorkReportModal from './TemplateWorkReportModal/TemplateWorkReportModal';
import EndServiceModal from './EndServiceModal/EndServiceModal';
import ImputationModal from './ImputationModal/ImputationModal';
import StatusReferenceModal from './StatusReferenceModal/StatusReferenceModal';
import NewValueImputationModal from './NewValueImputationModal/NewValueImputationModal';
import ApproveOrRejectSelectedQuantitiesModal from './ApproveOrRejectSelectedQuantitiesModal/ApproveOrRejectSelectedQuantitiesModal';
import ProgramPointModalFormik from './ProgramPointModal/ProgramPointModalFormik';
import AcceptModal from './AcceptModal/AcceptModal';
import SupportingDocumentModal from './SupportingDocumentModal/SupportingDocumentModal';

const WorkReportModals = ({ showModal, onHide, isOyM, ...props }) => {
  const {
    totalLineModal,
    attachFileModal,
    commentsModal,
    quantityEntryModal,
    monthlySummaryModal,
    rejectModal,
    approveAllModal,
    expertReviewModal,
    modifyImputationModal,
    modifyNewValueImputationModal,
    inspectorExpertReviewModal,
    editQuantityModal,
    confirmApprovalModal,
    templateWorkReportModal,
    endServiceModal,
    statusReferenceModal,
    approveOrRejectSelectedQuantitiesModal,
    programPointModal,
    imputationObjectModal,
    programPointApprovalModal,
    acceptModal,
    imputationApproval,
    supportingDocumentModal,
    replaceLinesSuccessModal
  } = showModal;

  return (
    <>
      {totalLineModal && <TotalLineModal onHide={onHide} show={totalLineModal} {...props} />}

      {attachFileModal && <AttachFileModal onHide={onHide} show={attachFileModal} {...props} />}

      {commentsModal && <CommentsModal onHide={onHide} show={commentsModal} {...props} />}

      {quantityEntryModal && (
        <QuantityEntryModal onHide={onHide} show={quantityEntryModal} {...props} />
      )}

      {monthlySummaryModal && (
        <MonthlySummaryModal onHide={onHide} show={monthlySummaryModal} {...props} />
      )}

      {rejectModal && <RejectModal onHide={onHide} show={rejectModal} {...props} />}

      {approveAllModal && <ApproveAllModal onHide={onHide} show={approveAllModal} {...props} />}

      {expertReviewModal && (
        <ExpertReviewModal onHide={onHide} show={expertReviewModal} {...props} />
      )}

      {modifyImputationModal && (
        <ImputationModal onHide={onHide} show={modifyImputationModal} {...props} />
      )}

      {modifyNewValueImputationModal && (
        <NewValueImputationModal onHide={onHide} show={modifyNewValueImputationModal} {...props} />
      )}

      {inspectorExpertReviewModal && (
        <InspectorExpertReviewModal onHide={onHide} show={inspectorExpertReviewModal} {...props} />
      )}

      {editQuantityModal && (
        <EditQuantityModal onHide={onHide} show={editQuantityModal} {...props} />
      )}

      {confirmApprovalModal && (
        <ConfirmApprovalModal onHide={onHide} show={confirmApprovalModal} {...props} />
      )}

      {templateWorkReportModal && (
        <TemplateWorkReportModal
          isOyM={isOyM}
          onHide={onHide}
          show={templateWorkReportModal}
          {...props}
        />
      )}

      {replaceLinesSuccessModal && <ReplaceLinesSuccessModal onHide={onHide} show {...props} />}

      {endServiceModal && <EndServiceModal onHide={onHide} show={endServiceModal} {...props} />}

      {statusReferenceModal && (
        <StatusReferenceModal onHide={onHide} show={statusReferenceModal} {...props} />
      )}
      {imputationApproval && <ModalIO onHide={onHide} show={imputationApproval} {...props} />}

      {approveOrRejectSelectedQuantitiesModal && (
        <ApproveOrRejectSelectedQuantitiesModal
          onHide={onHide}
          show={approveOrRejectSelectedQuantitiesModal}
          {...props}
        />
      )}

      {programPointModal && (
        <ProgramPointModalFormik onHide={onHide} show={programPointModal} {...props} />
      )}
      {imputationObjectModal && (
        <ImputationObjectModal onHide={onHide} show={imputationObjectModal} {...props} />
      )}
      {programPointApprovalModal && (
        <ModalProgramPointApproval onHide={onHide} show={programPointApprovalModal} {...props} />
      )}

      {supportingDocumentModal && (
        <SupportingDocumentModal onHide={onHide} show={supportingDocumentModal} {...props} />
      )}
      {acceptModal && <AcceptModal onHide={onHide} show={acceptModal} {...props} />}
    </>
  );
};

export default WorkReportModals;

WorkReportModals.propTypes = {
  showModal: PropTypes.objectOf(PropTypes.bool).isRequired,
  onHide: PropTypes.func,
  isOyM: PropTypes.bool
};

WorkReportModals.defaultProps = {
  onHide: () => {
    /* Empty */
  },
  isOyM: false
};
